<template>
  <label
    :id="id"
    class="text-background-fg/87 mb-2 block text-xs font-semibold"
  >
    <slot>{{ label }}</slot>
  </label>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
  id: string;
}>();
</script>
